/* @flow */
import * as React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';

// Utils
import messages from 'src/shared/domain/topic/l10n/topicL10n';
import {
  getBraindateTopic,
  isBraindateLive,
} from 'src/shared/domain/braindate/util/braindateUtil';
import {
  isGroupTopic,
  isFishbowlTopic,
} from '@braindate/domain/lib/topic/util';

// Styles
import styles from './BraindateCardTags.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Components
import LiveTag from 'src/shared/app/braindate/component/LiveTag.js';
import SecondaryTag from 'src/shared/ui/component/data-display/SecondaryTag';
import TopicFormatTag from 'src/shared/components/domain/topic/feed/TopicFormatTag';

// Type
import type { Braindate } from '@braindate/domain/lib/braindate/type';

const useStyles = createUseThemeStyles(styles);

type Props = {
  braindate: Braindate,
  className?: string,
};

const BraindateCardTags = ({ braindate, className }: Props) => {
  const classes = useStyles();
  const intl = useIntl();
  const topic = getBraindateTopic(braindate);
  const isGroupBraindate = isGroupTopic(topic);

  const isLive = isBraindateLive(braindate);

  const getTopicType = () => {
    if (isGroupBraindate) {
      if (isFishbowlTopic(topic)) return intl.formatMessage(messages.fishbowl);
      return intl.formatMessage(messages.group);
    }

    return intl.formatMessage(messages.oneOnOne);
  };

  return (
    <div className={classNames(classes.root, className)}>
      {isLive && <LiveTag />}
      <SecondaryTag>{getTopicType()}</SecondaryTag>
      <TopicFormatTag topic={topic} isConversationFormatEnabled />
    </div>
  );
};

export default React.memo<Props>(BraindateCardTags);
